module.exports = "/assets/ntctf25.jpg";